<div class="common-checkbox" (click)="toggler()" [ngClass]="color">
    <div class="toggler" [class.active]="value">
        <img src="/assets/icons/check-light.svg">
    </div>
    <div class="label" *ngIf="label">{{ label }}</div>
</div>